import $ from 'jquery';
import {is_array} from '../../../Helpers/js/simple.functions';
import LP from '../0-lp';
import UI from '../0-ui';
import {get} from '../../../Core/Request.js';

LP.pollResultsPage = {
    isReloading: false,
    mode: 'general',
    urls: {
        'general': 'backend/getOverviewResults/',
        'questions': 'backend/getSummarizedResults/',
        'compare': 'backend/getComparedResults/',
        'samples': 'backend/getSingleResults/',
        'codings': 'backend/getCodings/'
    },

    init: function (mode) {
        const doInit = function () {
            LP.pollResultsPage.mode = mode || 'general';
            LP.pollResultsFilter.init('#lp-results-filters');
            LP.pollResultsPage.cbReload('body');
        };

        if ($('#googleChartsLoader').length == 0) {
            const googleChartsLoader = document.createElement('script');
            googleChartsLoader.id = 'googleChartsLoader';
            googleChartsLoader.src = 'https://www.gstatic.com/charts/loader.js';
            googleChartsLoader.async = true;
            googleChartsLoader.onload = doInit;
            document.body.appendChild(googleChartsLoader);
        } else {
            doInit();
        }

    },

    cbReload: function (root) {

        if (!root) {
            root = 'body';
        }

        LP.initProgressBars(root);

        // Page nach Mode initialisieren
        var mode = LP.pollResultsPage.mode;

        let filterDiv = $('#lp-results-filters');
        if (mode == 'codings') {
            filterDiv.hide();
        } else {
            filterDiv.show();
        }

        if (mode === 'general') {
            // goto react
            const resultsDashboardDOMNode = document.getElementById('results-dashboard-react');
            if (resultsDashboardDOMNode && !resultsDashboardDOMNode.getAttribute('data-init')) {
                window.reactPortals.addReactResultsDashboard(resultsDashboardDOMNode, {onLoad: LP.pollResultsPage.onLoadReactContent});
                resultsDashboardDOMNode.setAttribute('data-init', true);
            }
        }

        if (mode === 'questions') {
            $('div[action="loadQuestionResults"]').click(LP.pollResultsPage.showQuestionResults);
            LP.pollResultsPage.disablePrintChartsButton();
            LP.dlgExportResults.prepare('a[dialog="exportResults"]', {});
        }

        if (mode === 'codings') {
            $('a[action="resetVars"]', root).click(LP.pollResultsCodings.resetVars);
            $('a[action="saveCodings"]', root).click(LP.pollResultsCodings.saveCodings);

            $('div[action="showCodings"]', root).click(LP.pollResultsCodings.toggleCodings);
            $('a[action="showDetails"]', root).click(LP.pollResultsCodings.toggleDetails);
            $('a[action="showAllDetails"]', root).click(LP.pollResultsCodings.toggleAllDetails);
        }

        if (mode === 'compares') {
            LP.pollResultsCompare.init(root);
        }

        // Filter anzeigen
        var filter = $('#lp-results-filter');
        filterDiv = $('#lp-results-filters');
        if (filterDiv.isVisible()) {
            if (filter.isVisible()) filter.slideUp();
            if (!filter.isVisible()) filter.slideDown();
        }

        $('a[toggle]', filterDiv).unbind('click').click(function () {
            $($(this).attr('toggle'), filterDiv).slideToggle();
        });

        if (mode == 'samples') {
            $(root + ' select[action="changeResponseKey"]').unbind('change').change(LP.pollResultsPage.changeResponseKey);
            $(root + ' a[action="refreshResponse"]').unbind('click').click(LP.pollResultsPage.refreshResponse);
            $(root + ' a[action="nextResponse"]').unbind('click').click(LP.pollResultsPage.nextResponse);
            $(root + ' a[action="prevResponse"]').unbind('click').click(LP.pollResultsPage.prevResponse);

            $(root + ' a[action="deleteResponse"]').unbind('click').click(function () {
                LP.pollResultsPage.deleteResponse($(this).attr('poll'), $(this).attr('confirm'));
            });
            $(root + ' a[action="toggleDeleteMultiple"]').unbind('click').click(LP.pollResultsPage.toggleDeleteMultiple);
            $(root + ' a[action="deleteMultiple"]').not('[disabled]').unbind('click').click(function () {
                LP.pollResultsPage.deleteMultiple($(this).attr('poll'), $(this).parent().find('textarea[name="responses"]').val(), $(this).attr('type'), $(this).attr('confirm'));
            });
        }

        // Sonstige Inits

        LP.pollResultsPage.initQuestionBlock(root, mode, false);
    },
    onLoadReactContent: function () {
        LP.dlgExportResults.prepare('a[dialog="exportResults"]', {});
        LP.dlgExportResults.prepare('a[dialog="exportStatistics"]', {});
    },

    initQuestionBlock: function (root) {
        LP.initProgressBars(root);

        LP.dlgExportResults.prepare('#lp-export-buttons a[dialog="exportQuestionResults"]', {});

        var resultCharts = new Array();

        // Init resultblock and collect result charts
        $('.resultblock', root).each(function (index, block) {

            // Init buttons
            LP.dlgExportResults.prepare('#' + block.id + ' a[dialog="exportQuestionResults"]', {});

            // Abs/Rel-Mode Toggle
            $('input.result_show_mode', block).click(function () {
                var updateCharts = LP.pollResultsPage.updateActiveChart(block, true);
                LP.pollResultsPage.drawResultCharts(root, updateCharts);
            });

            $('a[action="toggleChart"]', block).click(function () {
                LP.pollResultsPage.showResultCharts(block, $(this));
            });

            resultCharts = resultCharts.concat(LP.pollResultsPage.updateActiveChart(block, false));
        });

        // Render collected result charts
        if (resultCharts.length > 0) {
            LP.pollResultsPage.drawResultCharts(root, resultCharts);
        }
    },

    updateActiveChart: function (block, forceRefresh) {
        // Find & show active chart in block
        var resultCharts = new Array();

        var activeChartButton = $('a[action="toggleChart"].active', block);
        if (activeChartButton.length === 0) activeChartButton = $('a[action="toggleChart"]', block).first();
        if (activeChartButton.length !== 0) {
            $('a[action="toggleChart"]', block).removeClass('active');
            $('div[chart-type]', block).html('');
            activeChartButton.addClass('active');

            var charts = LP.pollResultsPage.fetchResultCharts(block, activeChartButton.attr('chart-type'), forceRefresh);
            for (var i = 0; i < charts.length; i++) {
                resultCharts.push(charts[i]);
            }
        }

        return resultCharts;
    },

    fetchResultCharts: function (block, chartType, forceRefresh) {
        var charts = $('div[chart-type="' + chartType + '"]', block);
        var mode = $('input[name="show_mode"]:checked', block).val();

        if (chartType == 'histogram') {
            LP.pollResultsPage.enableResultModes(block, false, true);
            charts.attr('value-format', 'abs');
        } else {
            LP.pollResultsPage.enableResultModes(block, true, true);

            charts.each(function (index, chart) {
                var format = $(chart).attr('value-format');
                if (format != 'rpc') $(chart).attr('value-format', mode);
                if (format == 'rpc' && mode == 'abs') $(chart).attr('chart-hidden', '1'); else $(chart).removeAttr('chart-hidden');
            });
        }

        var results = LP.UI.GoogleCharts.fetchChart(charts, true, forceRefresh);
        return results;
    },

    enableResultModes: function (block, allowRelative, allowAbsolute) {
        if (allowRelative) {
            $('.show_rel_result', block).removeAttr('disabled', '1').parent().removeClass('disabled');
        } else {
            $('.show_rel_result', block).attr('disabled', '1').prop('checked', false).parent().addClass('disabled');
            $('.show_abs_result', block).prop('checked', true);
        }

        if (allowAbsolute) {
            $('.show_abs_result', block).removeAttr('disabled', '1').parent().removeClass('disabled');
        } else {
            $('.show_abs_result', block).attr('disabled', '1').prop('checked', false).parent().addClass('disabled');
            $('.show_rel_result', block).prop('checked', true);
        }
    },

    drawResultCharts: function (block, resultCharts) {
        LP.UI.GoogleCharts.renderCharts(resultCharts);
    },

    showResultCharts: function (block, anchor) {
        $('a[action="toggleChart"]', block).removeClass('active');
        $('div[chart-type]', block).html('');
        anchor.addClass('active');

        // Collect all underlying charts
        var resultCharts = LP.pollResultsPage.fetchResultCharts(block, anchor.attr('chart-type'), false);

        // Query & draw all underlying charts
        LP.pollResultsPage.drawResultCharts(block, resultCharts);
    },

    getSampleViewParams: function () {
        var params = '';
        var items = $('.sample-toggle-icon');
        items.each(function (index, item) {
            var $item = $(item);
            var itemId = $item.attr('id');
            if (itemId) {
                var itemState = $item.hasClass('icon-down-dir') || $item.is(':checked');
                params += '&' + itemId + '=' + (itemState ? '1' : '0');
            }
        });

        params += '&showCodings=' + ($('#showCodings').is(':checked') ? '1' : '0');
        return params;
    },

    changeResponseKey: function () {
        if (LP.pollResultsPage.isReloading) return false;
        LP.pollResultsPage.reloadResponse($(this).val());
    },

    spinResponseKey: function () {
        if (LP.pollResultsPage.isReloading) return false;
        var pos = parseInt($('#lp-single-result-spin').val());
        LP.pollResultsPage.reloadResponse(pos - 1);
    },

    nextResponse: function () {
        if (LP.pollResultsPage.isReloading) return false;
        LP.pollResultsPage.reloadResponse('next');
    },

    prevResponse: function () {
        if (LP.pollResultsPage.isReloading) return false;
        LP.pollResultsPage.reloadResponse('prev');
    },

    refreshResponse: function () {
        var pos = $('#currentSample').val();
        LP.pollResultsPage.reloadResponse(pos);
    },

    reloadResponse: function (pos) {
        if (LP.pollResultsPage.isReloading) return false;

        var url = 'backend/showSingleResult/';
        var params = 'poll=' + $('#pollId').val() + '&samplePos=' + pos;
        params += LP.pollResultsPage.getSampleViewParams();
        const $div = $('#lp-single-result');
        $div.timedLoader(1);
        LP.pollResultsPage.isReloading = true;
        window.Browser.loadHTML($div, url, params, function () {
            $div.timedLoader(false);
            var pos = parseInt($('#currentSample').val());
            $('#sample-result-nr').html(pos + 1);
            $('#lp-single-result-spin').val(pos + 1);
            $('#lp-single-result-choice').val(pos);
            LP.pollResultsPage.isReloading = false;
            LP.pollResultsPage.cbReload('#lp-content-results');
        });
    },

    deleteResponse: function (poll, confirmText) {
        var pos = $('#responseNr').val();

        var onConfirm = function () {
            window.Browser.send('backend/deleteResponse/', 'poll=' + poll + '&responseNr=' + pos, function () {
                LP.pollResultsPage.reload();
            });
        };
        var onAbort = function () {
        };

        LP.UI.warnConfirm(confirmText, onConfirm, onAbort);
    },

    refreshPageWithLang: function () {
        LP.pollResultsPage.reload();
    },

    enableButton: function (button) {
        var isDisabled = button.attr('disabled');
        if (typeof isDisabled !== 'undefined' && isDisabled !== false) {
            button.removeAttr('disabled');
        }
    },

    disableButton: function (button) {
        var visibleCharts = $('.lp-section-content:visible');
        if (visibleCharts.length == 0) {
            button.attr('disabled', 'disabled');
        }
    },

    enablePrintChartsButton: function () {
        var btn = $('#lp-print-charts-btn');
        var newPrintBt = $('#new-chart-export-btx');
        LP.pollResultsPage.enableButton(btn);
        LP.pollResultsPage.enableButton(newPrintBt);
    },

    disablePrintChartsButton: function () {
        var btn = $('#lp-print-charts-btn');
        var newPrintBt = $('#new-chart-export-btx');
        LP.pollResultsPage.disableButton(btn);
        LP.pollResultsPage.disableButton(newPrintBt);
    },

    showQuestionResults: function () {
        var resultDiv = $(this).closest('.lp-section');
        return LP.pollResultsPage.openQuestionResults(resultDiv, false);
    },
    exportResultsToService: function (e) {
        e = e || window.event;
        e.preventDefault();

        const printBtn = $('#new-chart-export-btx');
        const isProcessing = printBtn.attr('processing');
        if (isProcessing) {
            return;
        }

        printBtn.attr('processing', true);

        const payload = {
            questionIds: [],
            itemTypes: [],
            frequencyTypes: [],
            freqRelTo: [],
            options: {},
        };

        const root = $('#lp-page-results');
        $('.resultblock:visible', root).each(function (index, block) {
            var activeChartButton = $('a[action="toggleChart"].active', block);
            if (activeChartButton.length === 0) activeChartButton = $('a[action="toggleChart"]', block).first();
            if (activeChartButton.length !== 0) {
                const chartType = activeChartButton.attr('chart-type');
                var charts = $('div[chart-type="' + chartType + '"]', block);

                const questionType = block.querySelector('#questionType').getAttribute("value");

                const ids = [];
                const valueFormats = [];
                charts.each(function () {
                    const params = LP.UI.GoogleCharts.getRequestData($(this));
                    ids.push(params.questionId);
                    valueFormats.push(params.options.valueFormat);
                });

                if (ids.length > 0) {
                    var itemType = chartType;
                    var options = {};

                    const val = $('input[name="show_mode"]:checked', block).val();
                    var freqType = 'abs';
                    if (val === 'rel') {
                        freqType = 'rel';
                    }


                    // resolve chart type
                    if (chartType === 'pie3d') {
                        itemType = 'pie';
                        options.is3d = true;
                    } else if (chartType === 'donut3d') {
                        itemType = 'donut';
                        options.is3d = true;
                    }

                    if (questionType === 'SCALE') {
                        if (chartType == 'stacked-column') {
                            itemType = 'column';
                            options.labelFormat = 'Ø {y}';
                            options.useStatValue = true;
                            options.statType = 'mean';
                            options.showDataLabels = true;
                        }
                    }

                    /* only multiple choice scales and questions can have relative to answered (respondents)
                     frequencies which are set for the standard report anyway
                     so make all relative frequencies relative to answers
                     */
                    var freqRelTo = 'answered';
                    if (questionType == 'CHOICE') {
                        freqRelTo = 'answers';
                        if (chartType == 'stacked-column')
                            itemType = 'column';
                        else if (chartType == 'stacked-bar')
                            itemType = 'bar';
                    }

                    if (questionType == 'MATRIX') {
                        if (valueFormats.includes('rpc')) {
                            freqRelTo = 'answers';
                        }
                    }

                    payload.frequencyTypes.push(freqType);
                    payload.freqRelTo.push(freqRelTo);

                    if (chartType === 'scatter' || chartType === 'line') {
                        options.showDataLabels = true;
                    }

                    if (itemType === 'stacked-column' || itemType === 'stacked-bar') {
                        options.showDataLabels = true;
                    }

                    const questionId = ids[0];
                    payload.questionIds.push(Number(questionId));
                    payload.itemTypes.push(itemType);
                    payload.options[questionId] = options;
                }
            }
        });

        const fileName = 'results-' + Date.now() + '.pdf';
        const pollId = $('#pollId').val();

        get(`/polls/${pollId}/reports/standard`, payload, {
            headers: {
                'Accept': 'application/pdf'
            }
        })
            .then((data) => {
                var data = Uint8Array.from(atob(data.FileContent), c => c.charCodeAt(0));
                var blob = new Blob([data], {type: "octet/stream"});

                var link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = fileName;
                link.click();
            })
            .catch(console.error)
            .finally(() => {
                printBtn.removeAttr('processing');
            });
    },
    openQuestionResults: function (resultDiv, forceOpen) {
        var openBtn = $('div[action="loadQuestionResults"]', resultDiv);
        var queryURL = openBtn.attr('url');
        var queryParams = openBtn.attr('url_params');

        var questionId = $.deparam(queryParams || '').question;
        var results = $('#results_' + questionId);
        var questionPrintTitle = results.parent().find('.print-only');

        if (results.html() == '') {
            openBtn.removeClass('icon-right-open-1').addClass('icon-down-open-1');
            questionPrintTitle.removeClass('hide');
            results.timedLoader(1);

            results.slideDown('fast', function () {
                window.Browser.send(queryURL, queryParams, function (json) {
                    results.timedLoader(false);
                    results.html(json.html);
                    LP.pollResultsPage.initQuestionBlock(results, '', true);
                    results.slideDown('fast', function () {
                        LP.pollResultsPage.enablePrintChartsButton();
                    });
                    LP.pollResultsPage.onOpenResults(results);
                });
            });
        } else {
            if (results.isVisible() && forceOpen) return LP.pollResultsPage.onOpenResults(results);

            if (results.isVisible()) {
                results.slideUp('fast', function () {
                    window.Browser.send('backend/closeQuestionResults/', queryParams);
                    openBtn.removeClass('icon-down-open-1').addClass('icon-right-open-1');
                    questionPrintTitle.addClass('hide');
                    LP.pollResultsPage.disablePrintChartsButton();
                },);
            } else {
                window.Browser.send('backend/openQuestionResults/', queryParams);
                openBtn.removeClass('icon-right-open-1').addClass('icon-down-open-1');
                questionPrintTitle.removeClass('hide');
                results.slideDown('fast', function () {
                    LP.pollResultsPage.enablePrintChartsButton();
                });
            }
        }
    },

    onOpenResults: function (results) {
        if ($('.lp-result-chartblock', results).html()) {
            $('.lp-result-chartblock', results).show();
            $('.lp-results-resulttable', results).hide();
        } else {
            $('.lp-result-chartblock', results).hide();
            $('.lp-results-resulttable', results).show();
        }
    },

    toggleSampleSection: function (anchor, ref) {
        var $icon = $('.sample-toggle-icon', anchor);
        var isVisible = $icon.hasClass('icon-down-dir');

        if (isVisible) {
            $icon.removeClass('icon-down-dir').addClass('icon-right-dir');
            $(ref).hide();
        } else {
            $icon.removeClass('icon-right-dir').addClass('icon-down-dir');
            $(ref).show();
        }
    },

    reload: function (params) {
        var div = $('#lp-content-results');
        var mode = LP.pollResultsPage.mode;
        var url = LP.pollResultsPage.urls[mode];
        params = params || {};
        params.poll = $('#pollId').val();

        div.timedLoader(1);
        window.Browser.loadHTML(div, url, params, function () {
            div.timedLoader(false);
            LP.pollResultsPage.cbReload('#lp-content-results');
        });
    },

    // used in template
    downloadZIPResults: function (anchor) {
        var url = $(anchor).attr('url');
        var url_params = $(anchor).attr('url_params');
        var onSuccess = function (json) {
            window.addTask(json.task, {closeAfter: 0});
            return true;
        };

        window.Browser.send(url, url_params, onSuccess);
    },
    toggleDeleteMultiple: function () {
        var $button = $('a[action="toggleDeleteMultiple"]').not('#lp-multiple-result-delete a[action="toggleDeleteMultiple"]');
        var $deleteView = $('#lp-multiple-result-delete');
        var $sampleView = $('#lp-single-result-view');

        if ($deleteView.isVisible()) {
            $deleteView.hide();
            $sampleView.show();
            $button.show();
        } else {
            $deleteView.show();
            $sampleView.hide();
            $button.hide();
        }
    },
    deleteMultiple: function (poll, keys, type, confirmText) {
        if (!keys || keys.length === 0) {
            UI.showMsgBox($('#emptyKeysText').html());
            return;
        }

        var onConfirm = function () {
            window.Browser.send('backend/deleteMultipleResponses/', 'poll=' + poll + '&selected[ids]=' + encodeURI(keys) + '&type=' + type, function () {
                LP.pollResultsPage.reload();
            });
        };
        var onAbort = function () {

        };
        LP.UI.warnConfirm(confirmText, onConfirm, onAbort);
    }
};

// ----------------------- //
// Chart Functions         //
// ----------------------- //
LP.pollResultsCharts = {

    inChartQuestChange: false,
    inChartRegionChange: false,
    inChartTypeChange: false,
    inChartStyleChange: false,
    inChartUpdate: false,

    initChart: function (root) {

        $('select[action="changeQuestion"]', root).change(function () {
            LP.pollResultsCharts.onChangeQuestion($(this));
        });

        LP.pollResultsCharts.onChangeQuestion($('select[action="changeQuestion"]', root));

        $('select[action="changeQuestionRegion"]', root).change(function () {
            LP.pollResultsCharts.onChangeRegion($(this));
        });

        LP.UI.initButtonMenu({
            selector: '#lp-menubar-charts',
            name: 'resultCharts',
            group: 'a[action="setChartType"]',
            click: LP.pollResultsCharts.onChangeChartType
        });

        $('.lp-chart-style-select').change(function () {
            var chart_type = $(this).val();
            LP.pollResultsCharts.onChangeChartStyle(chart_type);
        });
        $('#chart-dot-style').change(LP.pollResultsCharts.updateChart);
        $('#chart-multicolor').click(LP.pollResultsCharts.updateChart);
        $('#chart-scaled').click(LP.pollResultsCharts.updateChart);
        $('#chart-title').click(LP.pollResultsCharts.updateChart);
        $('#table-border').click(LP.pollResultsCharts.updateChart);
        var chartTemplate = $('#chart-template');
        chartTemplate.blur(LP.pollResultsCharts.updateChart);
        chartTemplate.keypress(function (e) {
            if (e.which == 13) {
                LP.pollResultsCharts.updateChart();
                return false;
            }
            return true;
        });

        var alphaSlider = $('#chart-transparency-slider');
        var alphaParams = new Array();
        alphaParams['min'] = 0;
        alphaParams['max'] = 90;
        alphaParams['value'] = parseInt($('#chart-transparency').val());
        alphaParams['change'] = function () {
            $('#chart-transparency').val($('#chart-transparency-slider').slider('value'));
            LP.pollResultsCharts.updateChart();
        };
        alphaSlider.slider(alphaParams);

        UI.setupSpinbox($('#chart-width'), 100, 750, 400, 10, false, '', true, false, true);
        UI.setupSpinbox($('#chart-height'), 100, 750, 400, 10, false, '', true, false, true);
    },

    onChangeQuestion: function (select) {
        if (LP.pollResultsCharts.inChartQuestChange) return;
        LP.pollResultsCharts.inChartQuestChange = true;

        $('.chart_error').hide();

        var request = select.val();

        if (request) {
            var param = '&question=';
            var question = request.substr(request.indexOf(param) + param.length);

            $('#lp-chart-question').val(question); // set question
            $('#lp-question-chart-select').show();
            $('.lp-chart-region').hide();           // Hide all
            $('#lp-chart-region-' + question).show(); // Show specific

            LP.pollResultsCharts.onChangeRegion($('#lp-chart-region-' + question + ' select'));
        } else {
            $('#lp-question-chart-select').hide();
            $('#lp-question-chart-types').hide();
            $('#lp-question-chart-styles').hide();
            $('#lp-question-chart').hide();
            $('#noValidRegions').show();

            LP.pollResultsCharts.inChartQuestChange = false;
        }
    },

    onChangeRegion: function (select) {
        if (LP.pollResultsCharts.inChartRegionChange) return;
        LP.pollResultsCharts.inChartRegionChange = true;

        $('.chart_error').hide();

        var region = select.val();

        var question = $('#lp-chart-question').val();

        if (region) {
            var params = $('#lp-chart-region-' + question + '-' + region).val();
            var charts = $('#lp-chart-types-' + question + '-' + region).val();

            $('#lp-chart-region').val(params);
            $('#lp-chart-regionId').val(region);

            var chart_types = new Array();
            if (charts) chart_types = charts.split(';');

            $('#lp-question-chart-types').show();
            $('#lp-chart-type .chart_type_button').addClass('hide');

            var current_type = $('#lp-chart-type').val();
            var has_chart_type = false;

            for (var i = 0; i < chart_types.length; i++) {
                if (current_type == chart_types[i]) {
                    has_chart_type = true;
                }
                $('#' + chart_types[i] + 'ChartLink').removeClass('hide');
            }
            if (!has_chart_type) current_type = chart_types[0];
            LP.pollResultsCharts.onChangeChartType($('#' + current_type + 'ChartLink'));
        } else {
            $('#lp-question-chart-types').hide();
            $('#lp-question-chart-styles').hide();
            $('#lp-question-chart').hide();
            $('#noValidTypes').show();
            LP.pollResultsCharts.inChartRegionChange = false;
            LP.pollResultsCharts.inChartQuestChange = false;
        }
    },

    onChangeChartType: function (anchor) {
        if (LP.pollResultsCharts.inChartTypeChange) return;
        LP.pollResultsCharts.inChartTypeChange = true;

        $('.chart_error').hide();

        var layout = $('#lp-question-chart-styles');

        if (anchor.is('[disabled]')) {
            layout.hide();
            $('#noValidChart').show();
            LP.pollResultsCharts.inChartTypeChange = false;
            LP.pollResultsCharts.inChartRegionChange = false;
            LP.pollResultsCharts.inChartQuestChange = false;
            return;
        }

        var chart_type = anchor.attr('mode');
        $('#lp-chart-type').val(chart_type);

        chart_type = 'jqplot';

        $('a[action="setChartType"]').removeClass('active');
        $('#' + anchor.attr('id')).addClass('active');

        layout.show();

        var styleDiv = $('.chart_style_' + chart_type, layout);
        $('.chart_input', layout).hide(); // Hide all
        styleDiv.show(); // show all specific

        // enable/disable stack mode
        var question = $('#lp-chart-question').val();
        var region = $('#lp-chart-regionId').val();
        var canStack = $('#lp-chart-stackable-' + question + '-' + region).val();

        if (canStack == '1') {
            $('#lp-bar-chart-stacked').removeAttr('disabled');
        } else {
            $('#lp-bar-chart-stacked').attr('disabled', 'disabled');
        }

        var chart_style = $('.lp-chart-style-select', styleDiv).val();

        LP.pollResultsCharts.onChangeChartStyle(chart_style);
    },

    onChangeChartStyle: function (style) {
        if (LP.pollResultsCharts.inChartStyleChange) return;
        LP.pollResultsCharts.inChartStyleChange = true;

        $('#chart-style').val(style);

        var chart_type = $('#lp-chart-type').val();

        if (style == 'bar_stack' || chart_type == 'pie' || chart_type == 'tab' || chart_type == 'box') {
            $('#lp-chart-multicolor').hide();
        } else {
            $('#lp-chart-multicolor').show();
        }

        LP.pollResultsCharts.updateChart();
    },

    updateChart: function () {
        if (LP.pollResultsCharts.inChartUpdate) return;
        LP.pollResultsCharts.inChartUpdate = true;
        LP.pollResultsCharts.loadChart();
    },

    loadChart: function () {
        $('#lp-question-chart').show(); // must be visible before

        var chart_request = LP.pollResultsCharts.getChartRequest();

        $('#lp-jqplotchart').html('');
        window.Browser.send('backend/getChartView/', chart_request, function (json) {
            $('#lp-jqplotchart').html(json.html);
            LP.UI.jQPlot.loadCharts();
            LP.pollResultsCharts.onLoadChart();
        });

    },

    onLoadChart: function () {
        LP.pollResultsCharts.inChartTypeChange = false;
        LP.pollResultsCharts.inChartQuestChange = false;
        LP.pollResultsCharts.inChartRegionChange = false;
        LP.pollResultsCharts.inChartStyleChange = false;
        LP.pollResultsCharts.inChartUpdate = false;
    },

    getChartRequest: function () {
        var request = $('#lp-base-chart-url').val();

        var params = LP.pollResultsCharts.getChartParams('');
        if (params) {
            request = request + params;
        }

        return request;
    },

    getChartParams: function (prefix) {
        var params = '';
        var form = $('#question-chart-form');
        $.each($('input,select', form), function (index, item) {
            var input = $(item),
                name = input.attr('name'),
                value;
            if (name && (input.isVisible() || input.attr('type') == 'hidden')) {
                var start = name.indexOf('['),
                    end = name.indexOf(']');
                if (start != -1 && end != -1) {
                    name = name.substring(start + 1, end);
                    if (input.attr('type') == 'checkbox') {
                        value = input.is(':checked') ? '1' : '0';
                    } else {
                        value = input.val();
                    }

                    if (name.substring(0, 6) == 'chart_') {
                        if (prefix) {
                            params = params + '&' + escape(prefix + '[' + name + ']') + '=' + escape(value);
                        } else {
                            params = params + '&' + name + '=' + escape(value);
                        }
                    }
                }
            }
        });
        return params;
    }

};

// ----------------------- //
// Result Codings Page     //
//------------------------ //

LP.pollResultsCodings = {
    toggleDetails: function () {
        var $this = $(this);
        var div = $('.varDetails', $this.parent().parent());
        div.toggle();
    },

    toggleAllDetails: function () {
        $('.varDetails').toggle();
    },

    toggleCodings: function () {
        var $header = $(this);
        var $section = $header.closest('.lp-section');
        var $content = $('.lp-section-content', $section);

        if ($content.isVisible()) {
            $content.slideUp('fast');
        } else {
            $content.slideDown('fast');
        }
    },

    resetVars: function () {
        var $this = $(this);
        var url = $this.attr('url');
        var params = $this.attr('url_params');
        var prefix = LP.prompt($this, 'V');

        if (prefix != null && prefix != '') {
            params += '&prefix=' + prefix;
            var $wrapper = $('#lp-content-results');
            $wrapper.timedLoader(1);
            window.Browser.loadHTML($wrapper, url, params, function () {
                $wrapper.timedLoader(false);
                LP.pollResultsPage.cbReload('#lp-content-results');
            });
        }
        return false;
    },

    saveCodings: function () {
        var form = $('#codingsForm');
        var resultDiv = $('#lp-content-results');
        resultDiv.timedLoader(1);

        var onCodingsSuccess = function () {
            resultDiv.timedLoader(false);
            LP.pollResultsPage.reload();
        };

        var onCodingErrors = function (json) {
            resultDiv.timedLoader(false);

            var displayErrors = '';
            for (const question in json.failures) {
                var questionErrs = '';
                for (const message in json.failures[question]) {
                    questionErrs += json.failures[question][message] + '<br>';
                }

                var errorDiv = $('#codingError_' + question);
                errorDiv.html(questionErrs);

                if (errorDiv.is(':visible')) {
                    errorDiv.transition('pulse');
                } else {
                    errorDiv.show();
                }

                // Coding-Block may not be visible, therefor display in error popup
                if (!errorDiv.is(':visible')) displayErrors += questionErrs;
            }

            var errorMsg = '';
            // Concrete errors
            if (displayErrors != '') {
                errorMsg = displayErrors;
            }
            // General errors
            else if (json.errors) {
                errorMsg = json.errors.join('<br>');
            }
            window.Toasts.errorToast(errorMsg);

            return true;
        };

        window.Browser.send(form.attr('action'), form.serialize(), onCodingsSuccess, onCodingErrors);

        return false;
    }
};

//----------------------- //
// Result Filterings      //
//----------------------- //

LP.pollResultsFilter = {
    init: function (filter) {
        $('a[filter]', filter).off('click', LP.pollResultsFilter.changeFilter).click(LP.pollResultsFilter.changeFilter);
        $('a[action="toggleResultFilter"]').off('click', LP.pollResultsFilter.toggleResultFilter).click(LP.pollResultsFilter.toggleResultFilter);
        LP.filters.init({
            root: filter,
            onClearFilter: LP.pollResultsFilter.filterResults
        });
        $('a[action="filterResults"]').off('click', LP.pollResultsFilter.filterResults).click(LP.pollResultsFilter.filterResults);

        // init loader
        $('#lp-resultsfilter-loader').hide();//.timedLoader(1);

        UI.suppressEnter('#resultFilterForm');
    },

    changeFilter: function ($this) {
        $this = $(this);
        if ($this.is('[disabled]')) return false;
        LP.UI.GoogleCharts.cache = {};
        $('#lp-result-filter').slideUp();

        $('a', $this.parent()).removeClass('active');
        $this.addClass('active');

        const params = {};
        if ($this.attr('filter') != '') params.filter = $this.attr('filter');
        if ($this.attr('poll') != '') params.poll = $this.attr('poll');
        params.refresh = 1;

        LP.pollResultsPage.reload(params);

        return true;
    },

    filterResults: function (nobutton) {
        var $this = $(this);
        if ($this.is('[disabled]')) return;
        LP.UI.GoogleCharts.cache = {};
        //var filter = $('#lp-result-filter');
        if (nobutton !== true) $('#lp-resultsfilter-loader').show();

        var onSuccess = function (json) {
            var numFiltered = json.numFiltered || 0;
            if (numFiltered) {
                $('#lp-num-filtered-results').html('(' + numFiltered + ')');
            } else {
                $('#lp-num-filtered-results').html('');
            }

            if (json.filterText) {
                $('#filterError').hide();
                $('#lp-filter-info').html(json.filterText).show();
            }

            if (json.sql) $('#lp-filter-sql').html(json.sql);

            LP.pollResultsPage.reload();

            if (nobutton !== true) {
                $('#lp-resultsfilter-loader').hide();
            }
        };

        var onError = function (json) {
            $('#lp-filter-info').hide();
            if (json.errors) {
                $('#filterError').show().html(json.errors?.join('<br/>'));
            }
            ;
            if (nobutton !== true) {
                $('#lp-resultsfilter-loader').hide();
            }

            return true;
        };

        var form = $('#resultFilterForm');
        var formURL = form.attr('action');
        var formData = form.serialize();

        window.Browser.send(formURL, formData, onSuccess, onError);
    },

    toggleResultFilter: function () {
        var filterDiv = $('#lp-result-filter');

        var $this = $(this);
        $('a', $this.parent()).removeClass('active');
        $this.addClass('active');
        if (filterDiv.isVisible()) {
            filterDiv.slideUp('fast');
        } else {
            filterDiv.slideDown('fast');
        }
    }

};


LP.pollResultsCompare = {

    init: function (root) {
        $('.cpgroup_filter', root).each(function (i, e) {
            LP.filters.init({root: $(e)});
        });

        $('#lp-results-filters').hide();

        $('.cpgroup_compareBy', root).change(function () {
            LP.pollResultsCompare.onSelectorChange('.compareBy', $(this), $(this).closest('.cpgroup'), true);
        });
        $('.cpgroup_nestedBy', root).change(function () {
            LP.pollResultsCompare.onSelectorChange('.nestedBy', $(this), $(this).closest('.cpgroup'), false);
        });

        $('.cpgroup_compareBy', root).each(function (index, select) {
            select = $(select);
            var refName = select.attr('name').replace('[question]', '');
            var block = select.closest('.cpgroup');
            LP.pollResultsCompare.onTemplateInit($('.compareByItems', block), refName);
        });

        $('.cpgroup_nestedBy', root).each(function (index, select) {
            var refName = $(select).attr('name').replace('[question]', '');
            var block = select.closest('.cpgroup');
            LP.pollResultsCompare.onTemplateInit($('.nestedByItems', block), refName);
        });

        $('a[action="resetCompare"]').click(function () {
            $('#lp-compare-results').html('');
            $('#lp-compare-errors').html('');
            window.Browser.send($(this).attr('url'), $(this).attr('url_params'), function () {
                window.location.reload();
            });
        });

        $('a[action="compareResults"]').click(function () {
            var form = $('#lp-compare-form');
            var url = form.attr('action');
            var data = form.serialize();

            $('#lp-compare-errors').slideUp();
            $('#lp-compare-results').timedLoader(1);
            window.Browser.send(url, data, LP.pollResultsCompare.onCompareSuccess, LP.pollResultsCompare.onCompareError);
        });
    },

    showFurtherCompares: function () {
        $('.toggleable-cg:hidden').first().show();
        if ($('.toggleable-cg:hidden').length == 0) $('#more-compare-groups').hide();
    },

    toggleCompareOptions: function (groupNr) {
        if ($('#toggle-options-' + groupNr).is(':checked')) {
            $('#seperation-options-' + groupNr).show();
        } else {
            LP.pollResultsCompare.resetCompareOptions(groupNr);
        }
    },

    resetCompareOptions: function (groupNr) {
        $('#seperation-options-' + groupNr).find('select').each(function () {
            $(this).prop('selectedIndex', 0);
            $(this).trigger('change');
        });

        $('#seperation-options-' + groupNr).hide();
    },

    onCompareSuccess: function (json) {
        var $button = $('a[action="compareResults"]');
        $button.removeClass('fs-16').addClass('fs-14');
        $button.removeClass('icon-check').addClass('icon-ccw');

        var $results = $('#lp-compare-results');
        $results.timedLoader(false);
        $results.html(json.html);

        // Hide group blocks for result view
        $('.cpgroup_form').each(function (index, node) {
            if ($(node).is(':visible')) {
                LP.pollResultsCompare.toggleGroup(index + 1);
            }
        });

        $('a[action="saveCompareResults"]', $results).click(function () {
            var url = 'backend/saveCompareResults';
            var url_params = $(this).attr('url_params');

            var onSuccess = function (json) {
                window.addTask(json.task, {closeAfter: 0});
            };

            window.Browser.send(url, url_params, onSuccess);
        });

    },

    onCompareError: function (json) {
        $('#lp-compare-results').timedLoader(false);
        var errors = is_array(json.errors) ? json.errors.join('<br>') : json.errors;
        $('#lp-compare-errors').html(errors).slideDown();
        return true;
    },

    hideGroup: function (groupNr) {
        if ($('#more-compare-groups').not(':visible')) $('#more-compare-groups').show();
        LP.pollResultsCompare.toggleGroup(groupNr);
        $('.cg-' + groupNr).hide();

        // reset all select dropdowns
        $('.cg-' + groupNr).find('select').each(function () {
            $(this).prop('selectedIndex', 0);
            $(this).trigger('change');
        });

        $('#toggle-options-' + groupNr).prop('checked', false);
        LP.pollResultsCompare.resetCompareOptions(groupNr);
    },

    toggleGroup: function (groupNr) {
        var group = $('.cpgroup_' + groupNr);
        var root = group.closest('.cpgroup');

        if (!group.is(':visible')) {
            group.slideDown('fast', LP.pollResultsCompare.onGroupToggle(root, false));
        } else {
            group.slideUp('fast', LP.pollResultsCompare.onGroupToggle(root, true));
        }
    },

    onGroupToggle: function (root, visible) {
        var icon = $('.toggle_icon', root);
        var header = $('.cpgroup_header', root);
        var activeIcon = $('.active_icon', root);

        if (visible) {
            icon.removeClass('icon-down-dir').addClass('icon-right-dir');
            $('.cpgroup-close-icon', root).hide(100);
            if (!activeIcon.hasClass('icon-ok')) {
                header.addClass('grey');
            }
        } else {
            icon.removeClass('icon-right-dir').addClass('icon-down-dir');
            $('.cpgroup-close-icon', root).show();
            if (activeIcon.hasClass('icon-ok')) {
                header.removeClass('grey');
            }
        }
    },

    onSelectorChange: function (ref, select, root, mandatory) {
        var setId = select.val();
        var refName = select.attr('name').replace('[question]', '');
        var itemsDiv = $(ref + 'Items', root);
        var header = $('.cpgroup_header', root);
        var activeIcon = $('.active_icon', itemsDiv.closest('.cpgroup'));
        if (setId.substr(0, 4) === 'ATTR') {
            var attrId = setId.substr(4);
            if (mandatory) {
                activeIcon.addClass('icon-ok').addClass('darkgreen');
                header.removeClass('grey');
            }
            var attrTemplates = $('#lp-compare-attrs-items-' + attrId);
            itemsDiv.html(attrTemplates.html()).show();
            LP.pollResultsCompare.onTemplateInit(itemsDiv, refName);
        } else if (setId) {
            if (mandatory) {
                activeIcon.addClass('icon-ok').addClass('darkgreen');
                header.removeClass('grey');
            }
            var itemsTemplates = $('#lp-compare-items-' + setId);
            itemsDiv.html(itemsTemplates.html()).show();
            LP.pollResultsCompare.onTemplateInit(itemsDiv, refName);
        } else {
            if (mandatory) {
                activeIcon.removeClass('icon-ok').removeClass('darkgreen');
            }
            itemsDiv.html('').hide();
        }
    },

    onTemplateInit: function (itemsDiv, refName) {
        var itemList = $('.itemsList', itemsDiv);

        var allItemsOptions = $('.allItems', itemsDiv);

        allItemsOptions.attr('name', refName + '[items][]');
        allItemsOptions.change(function () {
            var allSelected = $(this).is(':checked');
            if (allSelected) {
                itemList.hide();
            } else {
                itemList.show();
            }
            LP.pollResultsCompare.onItemsInit(itemsDiv, allSelected ? '' : refName);
        });

        var allSelected = allItemsOptions.is(':checked');

        LP.pollResultsCompare.onItemsInit(itemsDiv, allSelected ? '' : refName);
    },

    onItemsInit: function (itemsDiv, refName) {
        var itemList = $('.itemsList', itemsDiv);
        $('.singleItem', itemList).each(function (index, item) {
            item = $(item);
            if (!refName) {
                item.removeAttr('name');
            } else {
                item.attr('name', refName + '[items][]');
            }
        });

    },

    toggleResults: function (blockId, questionId) {
        var area = $('#lp-compare-results-' + blockId + '-' + questionId);
        if (!area.is(':visible')) {
            area.slideDown('fast', LP.pollResultsCompare.onResultsToggle(blockId, questionId, true));
        } else {
            area.slideUp('fast', LP.pollResultsCompare.onResultsToggle(blockId, questionId, false));
        }
    },

    onResultsToggle: function (blockId, questionId, visible) {
        if (visible) {
            LP.pollResultsCompare.setOpenResults(blockId, questionId);
            var area = $('#lp-compare-results-' + blockId + '-' + questionId);
            if (area.is(':empty')) {
                LP.pollResultsCompare.fetchResults(blockId, questionId);
            }
        } else {
            LP.pollResultsCompare.setClosedResults(blockId, questionId);
        }
    },

    fetchResults: function (blockId, questionId) {
        var area = $('#lp-compare-results-' + blockId + '-' + questionId);
        var url = area.attr('url');
        var data = area.attr('url_params');

        area.timedLoader(1);
        window.Browser.send(url, data, function (json) {
            area.timedLoader(false);
            LP.pollResultsCompare.onResultsSuccess(json, blockId, questionId);
        }, function (json) {
            area.timedLoader(false);
            return LP.pollResultsCompare.onResultsError(json, blockId, questionId);
        }, true, 180000);
    },

    onResultsSuccess: function (json, blockId, questionId) {
        var area = $('#lp-compare-results-' + blockId + '-' + questionId);
        area.html(json.html);

        $('a[action="exportDataTable"]', area).click(function () {
            LP.pollResultsCompare.exportResults(blockId, questionId);
            return false;
        });
        $('a[action="exportSplitTable"]', area).click(function () {
            LP.pollResultsCompare.exportResults(blockId, questionId);
            return false;
        });

        LP.pollResultsCompare.setOpenResults(questionId);
    },

    onResultsError: function (json, blockId, questionId) {
        var area = $('#lp-compare-results-' + blockId + '-' + questionId);
        area.html('');

        $('#lp-compare-results').html('');
        $('#lp-compare-errors').html(json.errors.join('<br>')).slideDown();
        LP.pollResultsCompare.setClosedResults(blockId, questionId);

        return true;
    },

    setOpenResults: function (blockId, questionId) {
        var block = $('#lp-compare-block-' + blockId + '-' + questionId);
        var icon = $('.icon', block);
        icon.removeClass('icon-right-dir').addClass('icon-down-dir');
    },

    setClosedResults: function (blockId, questionId) {
        var block = $('#lp-compare-block-' + blockId + '-' + questionId);
        var icon = $('.icon', block);
        icon.removeClass('icon-down-dir').addClass('icon-right-dir');
    },

    exportResults: function (blockId, questionId) {
        var area = $('#lp-compare-results-' + blockId + '-' + questionId);

        var options = $('.lp-datatable-options', area);

        var url = 'backend/exportCompareResults';
        var url_params = area.attr('url_params');

        options.each(function (index, optionDiv) {
            var toggle,
                state;
            index = index + 1;

            toggle = $('.val_c.toggle', optionDiv);
            if (toggle.length > 0) {
                state = $('input', toggle).is(':checked') ? 1 : 0;
            } else {
                state = 0;
            }
            url_params += '&val_c[' + index + ']=' + (state ? '1' : '0');

            toggle = $('.val_g.toggle', optionDiv);
            if (toggle.length > 0) {
                state = $('input', toggle).is(':checked') ? 1 : 0;
            } else {
                state = 0;
            }
            url_params += '&val_g[' + index + ']=' + (state ? '1' : '0');

            toggle = $('.val_t.toggle', optionDiv);
            if (toggle.length > 0) {
                state = $('input', toggle).is(':checked') ? 1 : 0;
            } else {
                state = 0;
            }
            url_params += '&val_t[' + index + ']=' + (state ? '1' : '0');
        });

        window.Browser.send(url, url_params, function (json) {
            window.addTask(json.task);
        });
    }
};
